import Icon from "@assets/icon_config";
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import { Col, Form, Input, Modal, Row, Spin, Tooltip } from "antd";
import { cloneDeep, forEach } from "lodash";
import React, { Fragment, useEffect, useRef, useState } from "react";
import HospitalListCMService from "@services/hospital-list-and-case-manager.service";

import "./modal.scss";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const HopitalListAddAndUpdateModal = (props: any) => {
  const isAddTableRowModalOpen = useHospitalMappingStore((state) => state.isAddTableRowModalOpen);
  const setIsAddTableRowModalOpen = useHospitalMappingStore((state) => state.setIsAddTableRowModalOpen);
  const isAddTableRowModalSaveDisabled = useHospitalMappingStore((state) => state.isAddTableRowModalSaveDisabled);
  const modalData = useHospitalMappingStore((state) => state.modalData);
  const modalMode = useHospitalMappingStore((state) => state.modalMode);
  const setisAddTableRowModalSaveDisabled = useHospitalMappingStore((state) => state.setisAddTableRowModalSaveDisabled);
  const activeTab = useHospitalMappingStore((state) => state.activeTab);
  const selectedHospitalListFacility = useGlobalInformationStore((state) => state.selectedHospitalListFacility);
  const currentpageMode = useHospitalMappingStore((state) => state.pageCurrentMode);

  const [formData, setFormData] = useState<any>([]);
  const [isModalLoading, setModalLoading] = useState<any>(false);
  const oldFormData: any = useRef();

  const filteredModalColData: any = modalData?.columnData?.filter((item) => {
    return item.is_display === "Y";
  });

  useEffect(() => {
    console.log("HopitalListAddAndUpdateModal.useEffect");
    let tempFormData: any = cloneDeep(filteredModalColData);
    tempFormData?.forEach((dataItem: any) => {
      dataItem["isDirty"] = false;
      dataItem["inputStatus"] = "";

      if (modalMode === "add") {
        dataItem["value"] = "";
      } else {
        dataItem["value"] = modalData.rowData[dataItem.column_key] === null ? "" : modalData.rowData[dataItem.column_key];
      }
    });
    oldFormData.current = tempFormData;
    setFormData(tempFormData);
    setisAddTableRowModalSaveDisabled(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalData, modalMode]);

  const handleAddNewHospitalMapping = () => {
    let pageName = "";
    let body: any = {};
    switch (activeTab) {
      case "1":
        pageName = "Hospitalists";
        body = {
          facilityName: selectedHospitalListFacility,
          hospitalistName: formData[0].value,
          hospitalistPhone: formData[1].value,
          hospitalistMail: formData[2].value,
          hospitalistFax: formData[3].value,
          supervisorName: formData[4].value,
          supervisorPhone: formData[5].value,
          supervisorMail: null,
          supervisorFax: null,
          newHospitalistName: null,
        };
        break;
      case "2":
        pageName = "Hospital Case Manager";
        body = {
          facilityName: selectedHospitalListFacility,
          caseManagerName: formData[0].value,
          caseManagerPhone: formData[1].value,
          caseManagerMail: formData[2].value,
          caseManagerFax: formData[3].value,
          newCaseManagerName: null,
        };
        break;
      case "3":
        pageName = "Payor Case Manager";
        body = {
          facilityName: selectedHospitalListFacility,
          payorName: formData[0].value,
          payorCaseManagerName: formData[1].value,
          payorCaseManagerPhone: formData[2].value,
          payorCaseManagerMail: formData[3].value,
          payorCaseManagerFax: formData[4].value,
          newPayorName: null,
        };
        break;
    }

    if (modalMode === "add") {
      HospitalListCMService.addNewHospitalMapping(pageName, body).subscribe({
        next: (v) => {
          HospitalListCMService.fetchHospitalMapping(selectedHospitalListFacility, currentpageMode).subscribe({
            next: (v) => {
              const response = v?.data?.data?.data;
              console.log(response);
              props.hospitalSetData(v?.data?.data?.data?.hospitalList);
              props.caseManagerSetData(v?.data?.data?.data?.caseManagerList);
              props.payorCaseManagerSetData(v?.data?.data?.data?.payorCaseManagerList);
              setModalLoading(false);
              setIsAddTableRowModalOpen(false);
            },
            error: (e) => {
              console.log(e);
              setModalLoading(false);
              setIsAddTableRowModalOpen(false);
            },
          });
        },
        error: (e) => {
          setModalLoading(false);
          setIsAddTableRowModalOpen(false);
        },
      });
    }

    if (modalMode === "edit") {
      switch (activeTab) {
        case "1":
          body["newHospitalistName"] = formData[0].value;
          body["hospitalistName"] = oldFormData.current[0].value;
          break;
        case "2":
          body["newCaseManagerName"] = formData[0].value;
          body["caseManagerName"] = oldFormData.current[0].value;

          break;
        case "3":
          body["newPayorName"] = formData[0].value;
          body["payorName"] = oldFormData.current[0].value;
          body["newPayorCaseManagerName"] = formData[1].value;
          body["payorCaseManagerName"] = oldFormData.current[1].value;

          break;
      }

      HospitalListCMService.editHospitalMapping(pageName, body).subscribe({
        next: (v) => {
          HospitalListCMService.fetchHospitalMapping(selectedHospitalListFacility, currentpageMode).subscribe({
            next: (v) => {
              props.hospitalSetData(v?.data?.data?.data?.hospitalList);
              props.caseManagerSetData(v?.data?.data?.data?.caseManagerList);
              props.payorCaseManagerSetData(v?.data?.data?.data?.payorCaseManagerList);
              setModalLoading(false);
              setIsAddTableRowModalOpen(false);
            },
            error: (e) => {
              console.log(e);
              setModalLoading(false);
              setIsAddTableRowModalOpen(false);
            },
          });
        },
        error: (e) => {
          console.log("error", e);
          setModalLoading(false);
          setIsAddTableRowModalOpen(false);
        },
      });
    }
  };

  const validationPrimaryKey = (inputText: any, prevValue: any, columnName: any, payorCaseManager?: string) => {
    let validatedText = true;

    let validObj = {
      validation: validatedText,
      error_message: "",
    };

    if (activeTab === "1") {
      forEach(props.hospitalData, (hospital: any) => {
        if (hospital?.hosplst_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase()) {
          if (modalMode === "edit" && oldFormData.current[0].value?.trim().toLowerCase() === inputText?.trim()?.toLowerCase()) {
            validatedText = true;
          } else {
            if (columnName === "hosplst_name") {
              validatedText = false;
            } else {
              validatedText = true;
            }
          }
        }
      });
      validObj = {
        validation: validatedText,
        error_message: "Hospitalist already exists!",
      };
    }

    if (activeTab === "2") {
      forEach(props.caseManagerData, (caseManager: any) => {
        if (caseManager?.hosplst_casemgr_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase())
          if (modalMode === "edit" && oldFormData.current[0].value?.trim().toLowerCase() === inputText?.trim()?.toLowerCase()) {
            validatedText = true;
          } else {
            if (columnName === "hosplst_casemgr_name") {
              validatedText = false;
            } else {
              validatedText = true;
            }
          }
      });
      validObj = {
        validation: validatedText,
        error_message: "Hospital Case Manager already exists!",
      };
    }
    if (activeTab === "3") {
      let validatedText = true;
      forEach(props.payorCaseManager, (payor: any) => {
        if (modalMode === "add") {
          if (columnName === "payor_name") {
            if (inputText?.trim()?.toLowerCase().length > 0) {
              if (
                payor?.payor_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase() &&
                formData[1]?.value?.trim().toLowerCase() === payor?.hosplst_payor_casemgr_name?.trim().toLowerCase()
              ) {
                validatedText = false;
              }
            }
          } else if (columnName === "hosplst_payor_casemgr_name") {
            if (inputText?.trim()?.toLowerCase().length > 0) {
              if (
                payor?.hosplst_payor_casemgr_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase() &&
                formData[0]?.value?.trim().toLowerCase() === payor?.payor_name?.trim().toLowerCase()
              ) {
                validatedText = false;
              }
            }
          }
        } else if (modalMode === "edit") {
          if (columnName === "payor_name") {
            if (inputText?.trim()?.toLowerCase().length > 0) {
              let a = props.payorCaseManager.filter((c: any) => {
                return inputText?.trim()?.toLowerCase() === c?.payor_name?.trim()?.toLowerCase() && c.hosplst_payor_casemgr_name?.trim()?.toLowerCase() === formData[1].value?.trim().toLowerCase();
              });
              if (a.length > 0) {
                if (inputText?.trim()?.toLowerCase() === oldFormData.current[0].value?.trim().toLowerCase()) {
                  validatedText = true;
                } else {
                  if (inputText?.trim()?.toLowerCase() === formData[0]?.value?.trim().toLowerCase()) {
                    validatedText = true;
                  } else {
                    validatedText = false;
                  }
                }
              } else {
                validatedText = true;
              }
            }
          } else if (columnName === "hosplst_payor_casemgr_name") {
            if (inputText?.trim()?.toLowerCase().length > 0) {
              let a = props.payorCaseManager.filter((c: any) => {
                return inputText?.trim()?.toLowerCase() === c?.hosplst_payor_casemgr_name?.trim()?.toLowerCase() && c.payor_name?.trim()?.toLowerCase() === formData[0].value?.trim().toLowerCase();
              });
              if (a.length > 0) {
                if (inputText?.trim()?.toLowerCase() === oldFormData.current[1].value?.trim().toLowerCase()) {
                  validatedText = true;
                } else {
                  if (inputText?.trim()?.toLowerCase() === formData[1]?.value?.trim().toLowerCase()) {
                    validatedText = true;
                  } else {
                    validatedText = false;
                  }
                }
              } else {
                validatedText = true;
              }
            }
          }
        }
      });
      validObj = {
        validation: validatedText,
        error_message: "Case Manager already exists for the payor!",
      };
    }

    return validObj;
  };

  return (
    <Fragment>
      <Modal
        wrapClassName="add-Facility-modal-container"
        title={modalData.title}
        visible={isAddTableRowModalOpen}
        width={"35%"}
        onCancel={() => {
          setIsAddTableRowModalOpen(false);
          setFormData(
            formData.map((dataItem: any, index: number) => {
              return { ...dataItem, value: "", inputStatus: "" };
            })
          );
        }}
        onOk={(e) => {
          setModalLoading(true);
          setFormData(
            formData.map((dataItem: any, index: number) => {
              return { ...dataItem, value: "", inputStatus: "" };
            })
          );
          handleAddNewHospitalMapping();
          setIsAddTableRowModalOpen(false);
        }}
        cancelButtonProps={{ hidden: true }}
        okButtonProps={{ disabled: isAddTableRowModalSaveDisabled }}
        zIndex={1000}
        okText="Save"
      >
        <Spin spinning={isModalLoading} indicator={<HealthemSpinner/>}>
          <AddTableRowDesign formData={formData} setFormData={setFormData} validation={validationPrimaryKey} />
        </Spin>
      </Modal>
    </Fragment>
  );
};

const AddTableRowDesign = ({ formData, setFormData, validation }: any) => {
  const setisAddTableRowModalSaveDisabled = useHospitalMappingStore((state) => state.setisAddTableRowModalSaveDisabled);

  return (
    <Form>
      {formData.map((dataItem: any, index: number) => {
        return (
          <Row className={`add-Facility-modal-container__row`} key={dataItem.column_key}>
            <Col span={12} className="add-Facility-modal-container__row__label">
              <Tooltip placement="topLeft" title="This is a required field">
                <span className="add-Facility-modal-container__row__label__container">
                  <span className="add-Facility-modal-container__row__label__container__required-star">*</span>
                  <span className="add-Facility-modal-container__row__label__container__question-field"> {dataItem.column_display_name}</span>
                </span>
              </Tooltip>
            </Col>
            <Col span={12}>
              <Input
                status={dataItem.inputStatus !== "" ? "error" : ""}
                className="add-Facility-modal-container__row__value"
                value={dataItem.value}
                onChange={(e) => {
                  const formDataClone = cloneDeep(formData);
                  let isFieldEmpty = false;
                  let ValidationObj = validation(e.target.value, dataItem.value, dataItem.column_key);

                  formDataClone.forEach((itemTobeChanged: any, itemTobeChangedIndex: number) => {
                    if (index === itemTobeChangedIndex) {
                      itemTobeChanged.value = e.target.value;
                      itemTobeChanged.isDirty = true;

                      if (itemTobeChanged.isDirty && e.target.value?.trim() === "") {
                        itemTobeChanged.inputStatus = "error";
                      } else if (!ValidationObj?.validation) {
                        itemTobeChanged.inputStatus = ValidationObj?.error_message;
                      } else {
                        itemTobeChanged.inputStatus = "";
                      }
                    }

                    // if (itemTobeChanged.column_key === "hosplst_payor_casemgr_name" || itemTobeChanged.column_key === "payor_name") {
                    //   if (ValidationObj?.validation) {
                    //     itemTobeChanged.inputStatus = "";
                    //   }
                    // }

                    if(ValidationObj?.validation && itemTobeChanged.inputStatus !== "error" && (itemTobeChanged.column_key === "hosplst_payor_casemgr_name" || itemTobeChanged.column_key === "payor_name")){
                      itemTobeChanged.inputStatus = "";
                    }

                    if (itemTobeChanged.value === "" || itemTobeChanged.inputStatus !== "") {
                      isFieldEmpty = true;
                    }
                  });

                  if (!isFieldEmpty) {
                    setisAddTableRowModalSaveDisabled(false);
                  } else {
                    setisAddTableRowModalSaveDisabled(true);
                  }

                  setFormData(formDataClone);
                }}
              />
              {(dataItem.inputStatus === "error" || dataItem.inputStatus !== "") && (
                <span className="error-message-container">
                  <span className="error-message-container__error-icon">
                    <Icon name="hrainfo" />
                  </span>
                  {dataItem.inputStatus === "error" ? "Field should not be empty" : dataItem.inputStatus}
                </span>
              )}
            </Col>
          </Row>
        );
      })}
    </Form>
  );
};

export default HopitalListAddAndUpdateModal;
